<div class="alert alert-danger" role="alert">
	IT pracuje w tym momencie nad innymi rozwiązaniami. W przyszłości tutaj będzie poczta wychodząca.
</div>
